import { ROUTES } from '@/features/core/container';
import { option } from '@/util/container';
import { component } from '../component';
import { APP_CUSTOMER } from './app.builder';

export default option(ROUTES, async () => {
  return [
    {
      path: '/customer/:customerId/vendor-apis/consumption-data-exchange/:vendorApiId',
      component: component('views/consumption-data-exchange/ConsumptionDataExchangeConfigurationView.vue'),
      props: true,
      meta: { app: APP_CUSTOMER, key: (): string => `AppCustomer/VendorApis/ConsumptionDataExchange` },
      children: [
        {
          path: '/customer/:customerId/vendor-apis/consumption-data-exchange/:vendorApiId',
          name: 'AppCustomer/VendorApis/ConsumptionDataExchange',
          meta: { app: APP_CUSTOMER },
          beforeEnter: ({ params }, from, next) =>
            void next({ name: 'AppCustomer/VendorApis/ConsumptionDataExchange/Settings', params }),
        },
        {
          path: 'settings',
          name: 'AppCustomer/VendorApis/ConsumptionDataExchange/Settings',
          component: component('views/consumption-data-exchange/settings/SettingsView.vue'),
          props: true,
          meta: { app: APP_CUSTOMER },
        },
      ],
    },
  ];
});
